
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.004 10.855h8.667c.532 0 .963.431.963.963v8.667a.963.963 0 01-.963.963h-8.667a.963.963 0 01-.963-.963V11.82c0-.533.43-.964.963-.964zm3.652 6.377l-2.043-2.043-.68.681 2.723 2.723.68-.68 3.406-3.405-.68-.68-3.406 3.404zm-5.224-4.772v4.618c-3.13.643-6.387.452-9.432-.6 0-4.241 3.724-4.24 4.551-5.348l.094-.506c-1.161-.588-1.981-2.007-1.981-3.666C4.664 4.773 6.086 3 7.84 3c1.753 0 3.175 1.773 3.175 3.958 0 1.645-.805 3.055-1.951 3.652l.108.575c.404.47 1.343.747 2.26 1.275z"}})])
          )
        }
      }
    